import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/home.vue"),
    children: [
      // {
      //   path: '/home/homepage',
      //   meta: {
      //     name: '首页',
      //   },
      //   component: () => import('@/views/home/homepage.vue'),
      // },
      {
        path: "/home/homepage",
        meta: {
          name: "首页",
        },
        component: () => import("@/views/home/homenew.vue"),
      },
      {
        path: "/building",
        redirect: "/notfound",
      },
      {
        path: "/notfound",
        name: "notfound",
        meta: {
          name: "未发现页面",
        },
        component: () => import("@/views/notfound.vue"),
      },
      //地图详情页面
      {
        path: "/home/homemapdetail",
        name: "homemapdetail",
        component: () => import("@/views/home/homemapdetail.vue"),
        meta: {
          path: "/home/homepage",
        },
      },
      {
        path: "/member/mapCar",
        name: "mapCar",
        component: () => import("@/views/member/mapCar.vue")
      },
      {
        path: "/member/overSpeedDetail",
        name: "overSpeedDetail",
        component: () => import("@/views/member/overSpeedDetail.vue")
      },
      // 货场
      {
        path: "/cargo/southcargo/:name",
        component: () => import("@/views/cargo/southcargo.vue"),
      },
      {
        path: "/cargo/trafficr",
        component: () => import("@/views/cargo/trafficr.vue"),
      },
      {
        path: "/cargo/cargolist/:id",
        component: () => import("@/views/cargo/cargolist.vue"),
      },
      // 审核管理
      {
        path: "/audit/auditcar",
        component: () => import("@/views/audit/auditcar.vue"),
      },
      {
        path: "/audit/awaitaudit",
        component: () => import("@/views/audit/awaitaudit.vue"),
      },
      {
        path: "/audit/entercancel",
        component: () => import("@/views/audit/entercancel.vue"),
      },
      {
        path: "/audit/infomsg/:id",
        component: () => import("@/views/audit/infomsg.vue"),
      },
      {
        path: "/audit/offlinetocancel",
        component: () => import("@/views/audit/offlinetocancel.vue"),
      },
      // 计划管理
      {
        path: "/plan/planlist",
        name: "planlist",
        component: () => import("@/views/plan/planlist.vue"),
      },
      {
        path: "/plan/planlobby",
        component: () => import("@/views/plan/planlobby.vue"),
      },
      {
        path: "/plan/planlistParticulars",
        name: "planlistParticulars",
        component: () => import("@/views/plan/planlistParticulars.vue"),
        meta: {
          path: "/plan/planlist",
        },
      },
      {
        path: "/plan/teampaln",
        component: () => import("@/views/plan/teamplan.vue"),
      },
      {
        path: "/plan/planinfo",
        component: () => import("@/views/plan/planinfo.vue"),
      },
      {
        path: "/plan/huoyun",
        component: () => import("@/views/plan/huoyun.vue"),
      },
      {
        path: "/plan/huoyunDetails",
        component: () => import("@/views/plan/huoyunDetails.vue"),
      },
      {
        path: "/plan/vanDetail",

        component: () => import("@/views/plan/vanDetail.vue"),
      },
      // 计划详情
      {
        path: "/plan/supplydetail",
        name: "supplydetail",
        component: () => import("@/views/plan/supplydetail.vue"),
      },
      {
        path: "/plan/jigang",
        component: () => import("@/views/plan/jigang.vue"),
      },
      {
        path: "/plan/daoyun",
        component: () => import("@/views/plan/daoyun.vue"),
      },
      {
        path: "/plan/shugang",
        component: () => import("@/views/plan/shugang.vue"),
      },
      // 代理管理
      {
        path: "/motorcade/motorcade",
        name: "motorcade",
        component: () => import("@/views/motorcade/motorcade.vue"),
      },
      {
        path: "/motorcade/newaddcheck",
        component: () => import("@/views/motorcade/newaddcheck.vue"),
      },
      {
        path: "/motorcade/newaddcheck2",
        name: "newaddcheck2",
        component: () => import("@/views/motorcade/newaddcheck2.vue"),
        meta: {
          path: "/motorcade/newaddcheck",
        },
      },
      {
        path: "/motorcade/particulars",
        name: "particulars",
        component: () => import("@/views/motorcade/particulars.vue"),
        meta: {
          path: "/motorcade/motorcade",
        },
      },
      // 会员管理
      {
        path: "/member/addcarlistinfo",
        name: "memverpartivulars",
        component: () => import("@/views/member/addcarlistinfo"),
        meta: {
          path: "/member/memberlist",
        },
      },
      {
        path: "/member/applyforcard",
        component: () => import("@/views/member/applyforcard"),
      },
      {
        path: "/member/blacklist",
        name: "blacklist",
        component: () => import("@/views/member/blacklist"),
      },

      {
        path: "/member/memberlist",
        name: "memberlist",
        component: () => import("@/views/member/memberlist"),
      },
      {
        path: "/member/cheliangguiji",
        component: () => import("@/views/member/cheliangguiji"),
      },
      {
        path: "/member/guijihuifang",
        name: "guijihuifang",
        component: () => import("@/views/member/guijihuifang"),
      },
      {
        path: "/member/lookspeeding",
        name: "lookspeeding",
        component: () => import("@/views/member/lookspeeding"),
      },
      
      {
        path: "/home/e-fenc",
        name: "eFenc",
        component: () => import("@/views/home/e-fenc"),
      },
      {
        path: "/home/map-fencing",
        name: "mapFencing",
        component: () => import("@/views/home/map-fencing"),
      },
      {
        path: "/home/fencingdemo",
        name: "fencingdemo",
        component: () => import("@/views/home/fencingdemo"),
      },
      {
        path: "/member/huifang",
        component: () => import("@/views/member/huifang"),
      },
      {
        path: "/member/newaddmember",
        component: () => import("@/views/member/newaddmember"),
      },
      {
        path: "/member/newaddparticulars",
        name: "newaddparticulars",
        component: () => import("@/views/member/newaddparticulars"),
        meta: {
          path: "/member/newaddmember",
        },
      },
      {
        path: "/member/tuckcomb",
        name: "tuckcomb",
        component: () => import("@/views/member/tuckcomb"),
      },
      {
        path: "/member/warehouse",
        name: "warehouse",
        component: () => import("@/views/member/warehouse"),
      },
      {
        path: "/member/carlog",
        name: "carlog",
        component: () => import("@/views/member/carlog"),
      },
      {
        path: "/member/energycar",
        name: "energycar",
        component: () => import("@/views/member/energycar"),
      },
      {
        path: "/member/energycarH",
        name: "energycarH",
        component: () => import("@/views/member/energycarH"),
      },
      // 角色权限
      {
        path: "/rolemanagement/addusers",
        component: () => import("@/views/rolemanagement/addusers"),
      },
      {
        path: "/rolemanagement/menumanager",
        component: () => import("@/views/rolemanagement/menumanager"),
      },
      {
        path: "/rolemanagement/rolejob",
        component: () => import("@/views/rolemanagement/rolejob"),
      },
      {
        path: "/rolemanagement/rolepeople",
        component: () => import("@/views/rolemanagement/rolepeople"),
      },
      // 统计分析
      {
        path: "/statistics/carstatistics",
        component: () => import("@/views/statistics/carstatistics"),
      },
      {
        path: "/statistics/gostatistics",
        component: () => import("@/views/statistics/gostatistics"),
      },

      {
        path: "/statistics/singleVehicleCost", //单车成本
        name: "singleVehicleCost",
        component: () => import("@/views/singleVehicleCost/index.vue"),
        meta: {
          name: "单车成本",
        },
      },
      {
        path: "/statistics/singleShipCost", //单船成本 
        component: () => import("@/views/singleShipCost/index.vue"),
      },
      {
        path: "/statistics/jobdetails",
        name: "jobdetails",
        component: () => import("@/views/statistics/jobdetails"),
      },

      {
        path: "/statistics/numstatistics",
        component: () => import("@/views/statistics/numstatistics"),
      },
      {
        path: "/statistics/regionalflow",
        component: () => import("@/views/statistics/regionalflow"),
      },
      {
        path: "/statistics/truestatistics",
        component: () => import("@/views/statistics/truestatistics"),
      },
      {
        path: "/statistics/enterThePS",
        component: () => import("@/views/statistics/enterThePS"),
      },
      {
        path: "/statistics/epinfomsg/:id",
        component: () => import("@/views/statistics/epinfomsg.vue"),
      },
      {
        path: "/statistics/eplist",
        component: () => import("@/views/statistics/eplist"),
      },
      {
        path: "/statistics/enterThePS2",
        component: () => import("@/views/statistics/enterThePS2"),
      },
      {
        path: "/statistics/doubleweight",
        component: () => import("@/views/statistics/doubleweight"),
      },
      {
        name: "carDataStatistics",
        path: "/statistics/carDataStatistics",
        component: () => import("@/views/statistics/carDataStatistics"),
      },
      // 公告管理
      {
        path: "/notice/noticelist",
        name: "noticelist",
        component: () => import("@/views/notice/noticelist"),
      },
      {
        path: "/notice/addnoticelist/:name",
        component: () => import("@/views/notice/addnoticelist"),
        meta: {
          path: "/notice/noticelist",
        },
      },
      // 运维管理
      {
        path: "/yunweiguanli/infoselect",
        name: "infoselect",
        component: () => import("@/views/yunweiguanli/infoselect"),
      },
      {
        path: "/yunweiguanli/versions",
        name: "versions",
        component: () => import("@/views/yunweiguanli/versions"),
      },
      // shangbaosearch
      {
        path: "/yunweiguanli/shangbaosearch",
        name: "shangbaosearch",
        component: () => import("@/views/yunweiguanli/shangbaosearch"),
      },
      {
        path: "/yunweiguanli/rizhi",
        name: "rizhi",
        component: () => import("@/views/yunweiguanli/rizhi"),
      },
      // 财务管理
      {
        path: "/financial/financialmanagement",
        name: "financialmanagement",
        component: () => import("@/views/financial/financialmanagement"),
      },
      {
        path: "/financial/truckorder",
        component: () => import("@/views/financial/truckorder"),
      },
      {
        path: "/financial/aRefundConfirmation",
        component: () => import("@/views/financial/aRefundConfirmation"),
      },
      {
        path: "/financial/refundDetailsList",
        component: () => import("@/views/financial/refundDetailsList"),
      },
      {
        path: "/financial/duizhang",
        component: () => import("@/views/financial/duizhang"),
      },
      {
        path: "/financial/carduizhang",
        component: () => import("@/views/financial/carduizhang"),
      },
      {
        path: "/other/exchange",
        component: () => import("@/views/other/exchange"),
      },
      //补能管理
      //充电
      {
        path: "/energy/addstore/addstoreinfo",
        name: "充电补能展示",
        component: () => import("@/views/energy/addstore/addstoreinfo"),
      },
      {
        path: "/energy/addstore/storeinfos",
        name: "充电设备图",
        component: () => import("@/views/energy/addstore/storeinfos"),
      },
      {
        //充电站列表
        path: "/energy/addstore/addstorestatelist",
        name: "addstorestatelist",
        component: () => import("@/views/energy/addstore/addstorestatelist"),
      },
      {
        //车辆充电详情
        path: "/energy/addstore/addstoredetail",
        name: "addstoredetail",
        component: () => import("@/views/energy/addstore/addstoredetail"),
        meta: {
          path: "/energy/addstore/addstorestatelist",
        },
      },
      {
        //车辆充电列表
        path: "/energy/addstore/caraddstorelist",
        name: "caraddstorelist",
        component: () => import("@/views/energy/addstore/caraddstorelist"),
      },
      {
        //充电记录
        path: "/energy/addstore/chargingpile",
        name: "chargingpile",
        component: () => import("@/views/energy/addstore/chargingpile"),
        meta: {
          path: "/energy/addstore/addstorestatelist",
        },
      },
      {
        //车辆换电列表
        path: "/energy/changestore/carchangestorelist",
        component: () =>
          import("@/views/energy/changestore/carchangestorelist"),
      },
      {
        //车辆换电展示
        path: "/energy/changestore/changestoreinfo",
        name: "changestoreinfo",
        component: () => import("@/views/energy/changestore/changestoreinfo"),
      },
      {
        //车辆换电站
        path: "/energy/changestore/changestorestatelist",
        component: () =>
          import("@/views/energy/changestore/changestorestatelist"),
      },
      {
        //车辆加氢列表
        path: "/energy/hydrogen/caraddhydrogenlist",
        component: () => import("@/views/energy/hydrogen/caraddhydrogenlist"),
      },
      {
        //加氢展示
        path: "/energy/hydrogen/hydrogeninfo",
        name: "hydrogeninfo",
        component: () => import("@/views/energy/hydrogen/hydrogeninfo"),
      },
      {
        //加氢站列表
        path: "/energy/hydrogen/hydrogenstatelist",
        component: () => import("@/views/energy/hydrogen/hydrogenstatelist"),
      },
      {
        //作业简报
        path: "/abandon/zuoyejianbao",
        component: () => import("@/views/abandon/zuoyejianbao"),
      },
      {
        //作业简报
        path: "/abandon/zuoyechaxun",
        name: "zuoyechaxun",
        component: () => import("@/views/abandon/zuoyechaxun"),
      },
      {
        //派车记录
        path: "/abandon/paichejilu",
        name: "paichejilu",
        component: () => import("@/views/abandon/paichejilu"),
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    meta: {
      name: "登录",
    },
    component: () => import("@/views/login.vue"),
  },
  {
    path: "/login-back",
    name: "login-back",
    meta: {
      name: "第三方登录",
    },
    component: () => import("@/views/login-back.vue"),
  },
  {
    path: "/other/pageinfo/:id",
    name: "pageinfoonly",
    meta: {
      name: "运单详情",
    },
    component: () => import("@/views/other/pageinfo"),
  },
  {
    path: "/other/paypage",
    name: "paypageonly",
    meta: {
      name: "运单详情",
    },
    component: () => import("@/views/other/paypage"),
  },
  // 大屏展示
  {
    path: "/largescreen",
    name: "largescreen",
    component: () => import("@/views/largescreen/home.vue"),
    children: [
      {
        path: "data", //疏港数据
        meta: {
          name: "疏港数据",
        },
        component: () => import("@/views/largescreen/data.vue"),
      },
      {
        path: "index", //首页
        meta: {
          name: "大屏首页",
        },
        component: () => import("@/views/largescreen/index.vue"),
      },
      // {
      //   path: 'scheduling',//货场调度
      //   meta: {
      //     name: "货场调度"
      //   },
      //   component: () => import('@/views/largescreen/scheduling.vue')
      // },
      {
        path: "fence", //货场调度
        meta: {
          name: "货场调度",
        },
        component: () => import("@/views/largescreen/fence.vue"),
      },
      {
        path: "energy", //节能环保
        meta: {
          name: "节能环保",
        },
        component: () => import("@/views/largescreen/energy.vue"),
      },
    ],
  },
  {
    path: "*",
    redirect: "/login",
  },
];
export default new VueRouter({
  routes,
});
